/**
 * NOTE: original read `state.referralInfo` (no parent namespace), which
 * doesn't exist — the real path is `state.memberships.referralInfo`
 * (confirmed against Dashboard.js's usage of the same module). Fixed here.
 */
import React, { useCallback, useEffect } from 'react';

import CSSModule from 'react-css-modules';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ShareRefCodeButton,Spinner, UndrawGiftIcon } from 'components';
import { actions } from 'coupon-common/src/modules/customerProfile';
import { actions as referralInfoActions } from 'coupon-common/src/modules/memberships/referralInfo';

import { RouteNames } from '../../../constants';
import msg from './messages';
import styles from './ReferralProgramForm.module.scss';

const ReferralProgramForm = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const referralInfo = useSelector(state => state.memberships.referralInfo);

  useEffect(() => {
    dispatch(referralInfoActions.getReferralInfo());
  }, [dispatch]);

  const renderEarnedBlock = () => {
    const { fetching, data, error } = referralInfo;

    if (fetching) {
      return <Spinner show size="sm" />;
    }
    if (error) {
      return <p styleName="error-text">{error}</p>;
    }
    if (data) {
      const earnedPoints = data?.first_level_referral_points;
      return (
        <>
          <h1 styleName="title">
            <FormattedMessage {...msg.earnPoints} values={{ earnedPoints }} />
          </h1>
          <p styleName="description">{intl.formatMessage(msg.forEachMember)}</p>
        </>
      );
    }
    return null;
  };

  const onFinishClick = useCallback(() => {
    dispatch(actions.getCustomerProfile());
    navigate(RouteNames.HOME);
  }, [dispatch, navigate]);

  const goToPrivacyPolicy = () => navigate(RouteNames.PRIVACY_POLICY);
  const goToTermsOfService = () => navigate(RouteNames.TERMS_OF_SERVICE);

  return (
    <div styleName="page">
      <div styleName="card">
        <div styleName="icon-wrap">
          <UndrawGiftIcon />
        </div>

        {renderEarnedBlock()}

        <h2 styleName="title" style={{ fontSize: '1.05rem' }}>
          {intl.formatMessage(msg.pointsToMoney)}
        </h2>
        <p styleName="description">{intl.formatMessage(msg.pointsDescription)}</p>

        <div styleName="share-wrap">
          <ShareRefCodeButton />
        </div>

        <p styleName="policy-text">
          <FormattedMessage
            {...msg.finishAgreement}
            values={{
              termsLink: content => (
                <button type="button" styleName="policy-link" onClick={goToTermsOfService}>
                  {content}
                </button>
              ),
              policyLink: content => (
                <button type="button" styleName="policy-link" onClick={goToPrivacyPolicy}>
                  {content}
                </button>
              ),
            }}
          />
        </p>

        <button type="button" styleName="finish-btn" onClick={onFinishClick}>
          {intl.formatMessage(msg.finishBtn)}
        </button>
      </div>
    </div>
  );
};

export default CSSModule(ReferralProgramForm, styles, { allowMultiple: true });
